import Vue from "vue";
import App from "./App.vue";
// import { router as routerSchwedt } from "./routerSchwedt";
// import { router as routerSchallerbach } from "./router";
import { router } from "./routerSchwedt";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import axios from "axios";
import VueAxios from "vue-axios";

// if (process.env.VUE_APP_BAD === 'schwedt') {
//   router = routerSchwedt;
// }
// else router = routerSchallerbach;

import './mlSchwedt';

// let vue use Bootstrap
Vue.use(BootstrapVue);
// let vue use axios global
// use it like this:
// Vue.axios.[get/...], this.axios.[get/...], this.$http.[get/...]
Vue.use(VueAxios, axios);

// import css for global use
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import './assets/schwedt/schwedt.css';

Vue.config.productionTip = true;
Vue.config.devtools = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
